import {
  ALL_CATEGORIES,
  HUB_MAJOR_IDS,
  isHubMajorCategory,
  resolveCategoryDisplayName,
} from '../data/mingoServiceCatalog';

/** @deprecated Prefer HUB_MAJOR_IDS from mingoServiceCatalog — same list. */
export const VALID_CATEGORIES = HUB_MAJOR_IDS;

const CATEGORY_ALIASES = {
  'food-mart': 'food_cafe_mart',
  food_mart: 'food_cafe_mart',
};

/** ko labels from ALL_CATEGORIES SSOT */
export const HUB_CATEGORY_LABELS = Object.fromEntries(
  ALL_CATEGORIES.map((c) => [c.id, resolveCategoryDisplayName(c, 'ko')]),
);

/**
 * @param {string|null|undefined} raw
 * @returns {string} hub major id or ''
 */
export function normalizeHubCategoryId(raw) {
  const key = String(raw || '').trim();
  if (!key) return '';
  const normalized = CATEGORY_ALIASES[key] || key;
  return isHubMajorCategory(normalized) ? normalized : '';
}

export function resolveHubCategoryFromPath(pathname) {
  const match = String(pathname || '').match(/\/hub\/([^/]+)/);
  if (!match) return '';
  return normalizeHubCategoryId(match[1]);
}

/**
 * Category for the top-bar search target:
 * - `/hub/:id` → hub major id
 * - `/search?category=` → keep scope when tapping search again on SearchPage
 * @param {{ pathname?: string, search?: string } | null | undefined} location
 */
export function resolveSearchCategoryFromLocation(location) {
  const fromPath = resolveHubCategoryFromPath(location?.pathname);
  if (fromPath) return fromPath;
  if (!location?.search) return '';
  try {
    const params = new URLSearchParams(location.search);
    return normalizeHubCategoryId(params.get('category'));
  } catch {
    return '';
  }
}

export function getHubCategoryLabel(category, language = 'ko') {
  const id = normalizeHubCategoryId(category) || String(category || '').trim();
  if (!id) return '';
  const cat = ALL_CATEGORIES.find((c) => c.id === id);
  if (cat) return resolveCategoryDisplayName(cat, language);
  return HUB_CATEGORY_LABELS[id] || '';
}

export function buildHubSearchPath({ q = '', category = '', tab = '' } = {}) {
  const p = new URLSearchParams();
  const term = String(q || '').trim();
  const cat = String(category || '').trim();
  const tabKey = String(tab || '').trim();
  if (term) p.set('q', term);
  if (cat) p.set('category', cat);
  if (tabKey && tabKey !== 'all') p.set('tab', tabKey);
  const s = p.toString();
  return s ? `/search?${s}` : '/search';
}

/** Search result tabs that can be deep-linked via ?tab= */
export const SEARCH_RESULT_TAB_KEYS = ['all', 'products', 'stories', 'posts', 'jobs', 'businesses'];

export function normalizeSearchTab(raw) {
  const key = String(raw || '').trim().toLowerCase();
  if (key === 'story') return 'stories';
  if (key === 'biz' || key === 'business') return 'businesses';
  return SEARCH_RESULT_TAB_KEYS.includes(key) ? key : '';
}
